import { render, staticRenderFns } from "./RelatedColorsItem.vue?vue&type=template&id=3391f8fe&scoped=true&"
import script from "./RelatedColorsItem.vue?vue&type=script&lang=js&"
export * from "./RelatedColorsItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedColorsItem.vue?vue&type=style&index=0&id=3391f8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3391f8fe",
  null
  
)

export default component.exports